import React, { FC } from 'react';

interface Props {
    activeScreen: number;
    total: number;
}

const ProgressBar: FC<Props> = ({ activeScreen, total }) => {
    const progress = (activeScreen / total) * 100;

    return (
        <div className="progress">
            <div className="progress__item" style={{ width: `${progress}%` }} />
        </div>
    );
};

export default ProgressBar;
